export default __webpack_public_path__ + "static/media/developmentHistory_bg.aee5a0e3.jpg";